export const NOTIFICATION = 'NOTIFICATION'
export const NOTIFICATION_SHOW = 'NOTIFICATION_SHOW'
export const NOTIFICATION_REMOVE_AFTER_DELAY = 'NOTIFICATION_REMOVE_AFTER_DELAY'
export const NOTIFICATION_ADD = 'NOTIFICATION_ADD'
export const NOTIFICATION_REMOVE = 'NOTIFICATION_REMOVE'
